import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-testimonials6',
  templateUrl: './section-testimonials6.component.html',
  styleUrls: ['./section-testimonials6.component.css']
})
export class SectionTestimonials6Component implements OnInit {

  @Input() data: any;
  
  constructor() { }

  ngOnInit(): void {
  }

}
